
export const Add_Client="Add_Client"
export const Get_Error="Get_Error"
export const Get_All_Clients="Get_All_Clients"



export const Add_Blog="Add_Blog"
export const Get_All_Blogs="Get_All_Blogs"
export const Get_one_Blog="Get_one_Blog"
export const Delete_Blog="Delete_Blog"

